/**
 * Axios request: add Authorization Bearer for API requests (except refresh).
 * Axios response: on 401, try refresh once, then retry; on refresh failure clear auth and Pinia state.
 */
import axios from 'axios';
import { applyAuthInterceptors } from './api/authInterceptors';

applyAuthInterceptors(axios);
